var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 859",
    width: 305,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v859h-2048z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,167)",
    d: "m0 0h114l1 1 1 10v302h17l7-6 6-10 10-15 12-19 26-40 14-21 3-3 26-1h107l2 2-6 10-18 27-21 31-13 19-14 20-30 45-3 6 1 6 7 11 7 10 8 12 13 19 13 18 13 19 16 23 14 20 16 24 10 14 1 3-11 1h-125l-11-1-30-48-17-28-14-22-15-23-7-8-6-2-6 1-1 3-1 49-1 76-1 2-6 1h-75l-42-1-1-8v-488l1-40z",
    fill: "#00999B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,355)",
    d: "m0 0h34l21 3 17 4 21 7 17 8 16 10 13 11 12 11 9 10 11 16 8 14 7 15 6 17 4 16 2 14 1 14v18l-2 24-5 23-6 17-10 21-10 15-9 11-19 19-16 12-16 9-20 9-27 8-27 3h-28l-28-3-21-6-19-8-17-9-14-10-14-12-10-10-11-14-8-13-10-19-7-19-4-17-3-22-1-12v-13l3-26 5-23 6-17 8-16 6-11 9-13 12-14 12-11 18-13 16-9 13-6 18-6 22-5z",
    fill: "#00999B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,220)",
    d: "m0 0h376l30 1-1 99-1 21-1 1-139 1-1 3-1 346-1 11-8 2h-110l-13-1-1-360-2-1-101-1-38-1-1-1v-101l1-18z",
    fill: "#00999B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1456,355)",
    d: "m0 0h29l22 3 20 5 19 7 21 11 12 9 10 9 10 13 10 15 10 21 7 22 4 19 2 21v43l-1 14-2 1-15 1h-178l-10-1-1 5 8 16 11 9 14 7 11 3 11 1h41l27-3 29-6 41-11h4v76l-1 30-6 3-26 7-31 6-49 4h-21l-34-3-20-4-21-6-19-8-17-9-14-10-13-11-12-12-12-17-9-15-8-17-5-15-5-26-2-21v-21l2-19 5-24 7-20 7-16 10-16 10-13 17-17 17-13 16-9 14-6 20-6 25-5z",
    fill: "#00999B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,470)",
    d: "m0 0h21l13 5 11 7 10 11 7 12 4 14 1 5v22l-5 17-9 16-8 9-11 7-16 5h-15l-13-4-9-5-9-8-7-10-6-13-4-17v-13l4-19 5-12 6-10 10-10 10-6z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1911,428)",
    d: "m0 0h10l8 4 7 7 5 10v8l-7 9-10 7-16 5-48 12-92 22-5 1h-10l-8-5-6-7-3-6v-12l5-10 8-5 24-7 66-16 54-13z",
    fill: "#00999B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1582,95)",
    d: "m0 0h9l9 4 7 6 5 8v10l-9 31-18 61-13 44-6 18-5 8-8 6-9 3-9-2-9-6-6-7-1-2v-11l7-27 24-79 10-34 6-17 5-8 8-5z",
    fill: "#00999B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1792,219)",
    d: "m0 0h10l8 3 5 5 6 9 1 9-3 8-9 11-13 12-7 7-8 7-17 16-8 8-8 7-11 11-8 7-7 7-11 9-10 10-14 9-6 2-8-1-9-7-6-8-1-3v-13l4-8 12-12 11-9 12-12 8-7 17-16 9-9 8-7 19-19 8-7 7-7 12-9z",
    fill: "#00999B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1339,90)",
    d: "m0 0h7l10 4 7 7 5 13 17 67 9 35 11 44v10l-3 9-5 6-8 4h-15l-8-3-6-9-6-19-20-79-15-60-1-9 5-10 7-6z",
    fill: "#00999B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(910,168)",
    d: "m0 0h20v1l-14 1-3 3v8l3 13 1 15 1 34v89l-1 34-1 11-1 25v137l-1 23v42l1 23-1 1 3 50 2 3 3 9 5 2 2 9-1 2h10v1h-28l-1-8v-488z",
    fill: "#008E95"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1468,457)",
    d: "m0 0 10 1 16 6 8 6 6 9 3 8 1 10-2 3h-67l-14 1-4-2 1-9 6-12 11-12 9-6 8-2z",
    fill: "#FEFEFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(245,354)",
    d: "m0 0 2 1 2 9 1 25v17l2 31v165l1 39v36l2 7 2 6h1v6l-4 2 1 6h-10z",
    fill: "#008D95"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,220)",
    d: "m0 0h376l29 1-3 5-38-1h-20l-49-2h-294l-6 4v85l1 9h1l2 11-1 4h2l1 4h-14v-101l1-18z",
    fill: "#008E95"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,413)",
    d: "m0 0 3 1-7 9-4 7-2 5-6 6-3 1-7 14-8 14-3 8h-2l-5 10-3 23-2 8 1 9 3 25 3 23 4 13 2 8 2 1-1 2 2 1 6 12 3 7 2 6-1 4 1 8-5-5-12-23-7-19-4-17-3-22-1-12v-13l3-26 5-23 6-17 8-16 6-11 5-7 5-2 3 1 4-4 2-4 5-3z",
    fill: "#008F96"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1320,439)",
    d: "m0 0 3 3-1 4h2l1 4 1-3 2 1-4 11-2 9-4 9-1 2h-2l-1 7-2-2v-7l-3 7-4 16h-2l-1 10-1 25 4 18 4 25 2 10 3 10 4 7 1 4-3 3h-3l-6-15-4-14-4-21-2-21v-21l2-19 5-24 7-20 7-16z",
    fill: "#008E95"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,355)",
    d: "m0 0h34l21 3 17 4 15 5 1 2-18-4-10-3-21-3-20-1h-17l-19 3-16 5-5 2h-7l-1 3-9 4h3 6l-3 2-11 5v2l-20 13-16 8-8 7-2-2 5-6 3-3-1-4-6 4 2-4 13-10 16-10 19-9 18-6 22-5z",
    fill: "#008D95"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,220)",
    d: "m0 0h376l29 1-3 5-38-1h-20l-49-2h-233v-2h-62z",
    fill: "#009498"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1334,169)",
    d: "m0 0 2 1v2l4 1 5 13 3 15-3 3-1 4 2 3 4-3 3 8 2-1 6 21 1 10-2-2-1 7 3 14v13l-3-3-10-36-16-63v-6z",
    fill: "#008E95"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1129,367)",
    d: "m0 0h5l1 5-4 1-9 22-8 11-6 8-2 1-1 3-4 3-5 9-5 6-3 3-1 2h-2l-2 6-1 7-8 9-3-1-5 4 1-5 10-15 15-24 10-15 11-17 14-21z",
    fill: "#008E95"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,413)",
    d: "m0 0 3 1-7 9-4 7-2 5-6 6-3 1-7 14-8 14-3 8h-2l-5 10-3 23-3 14h-1v-12l4-31 7-21 8-16 6-11 5-7 5-2 3 1 4-4 2-4 5-3z",
    fill: "#008D95"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,482)",
    d: "m0 0 6 2 5 3 7 10 2 6v5l3 1 4 10 3 14-1 10-3 12-5 14-11 15-3 1v-2h-2l2-4 9-16 5-17v-22l-4-16-6-12-9-11z",
    fill: "#008E95"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1565,120)",
    d: "m0 0 2 3-2 12-6 20-3 7-1 9-4 11h-4v-2h-2l1-7 11-37 4-9 3-6z",
    fill: "#008E96"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1142,366)",
    d: "m0 0h15v1l22 1 12-1 18-1h19l20 1v1l-32 1-22 4-4 1h-9l-21-2-5-2h-9l-1-2z",
    fill: "#008D95"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,221)",
    d: "m0 0h103l-3 5-38-1h-20l-42-2z",
    fill: "#008D95"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1379,378)",
    d: "m0 0 3 1-5 3 1 3h3l-8 9-8 5-10 8-4 2h-3l2-4h2v-3l-5 4-2-1 10-10 17-13z",
    fill: "#008E95"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1447,356)",
    d: "m0 0h14l14 1-2 2-24 4-7 2h-7l-9 2-4-2-4 1-5-1 1-2 26-6z",
    fill: "#008E95"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,355)",
    d: "m0 0h34l21 3 17 4 15 5 1 2-18-4-10-3-21-3-20-1h-17l-15 1-2-2z",
    fill: "#009096"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1811,452)",
    d: "m0 0h6l-3 1 1 3-12 3-9 3-8 2-13 1-9 1h-2v-2l40-10z",
    fill: "#008E96"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1614,590)",
    d: "m0 0h5v4h-2v2l-3 1-13 1-28 6-10 2h-6l2-2 26-6z",
    fill: "#008F96"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1189,460)",
    d: "m0 0 2 1 1 6-1 3-4 2-1 4 2 1-8 10-2 3h-2v-2l-3-1 4-7 6-13 5-5z",
    fill: "#008D95"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1893,432)",
    d: "m0 0h4v2l-9 3-2-1v2l-10 4-2-2h-3l-3 1 4 3-14 2-5-1 1-3 18-5z",
    fill: "#008F96"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1663,343)",
    d: "m0 0 2 2 1 4v7l-3 2v6l-4-4-1-3v-10l3-3z",
    fill: "#008E95"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1580,97)",
    d: "m0 0 2 2-2 5-9 9h-2l1-11 5-4z",
    fill: "#008D95"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1354,666)",
    d: "m0 0 6 2 15 11 6 4v2h2v2l-6-2-14-10-9-7z",
    fill: "#008F96"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,424)",
    d: "m0 0 4 2 11 17 9 19-1 2-12-22-6-10z",
    fill: "#009097"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(783,665)",
    d: "m0 0h4l-2 4-9 8h-3l1-6z",
    fill: "#008E96"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1117,677)",
    d: "m0 0 5 5 1 4 3 1v2l3 1 1 6v2h-2l-9-15-2-3z",
    fill: "#008F96"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,361)",
    d: "m0 0 7 1 15 5 1 2-18-4-5-2z",
    fill: "#008F96"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,596)",
    d: "m0 0 10 2 5 2-1 2h-7l-6-3z",
    fill: "#008F96"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1577,600)",
    d: "m0 0 4 1-9 3-9 2h-6l2-2z",
    fill: "#009197"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,385)",
    d: "m0 0 2 1-8 15-3 2 1-5 4-6 2-5h2z",
    fill: "#008D95"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1905,429)",
    d: "m0 0h6l1 2-8 2h-6l3-3z",
    fill: "#009197"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1469,609)",
    d: "m0 0h11l2 2-1 1h-7l-5-2z",
    fill: "#009197"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToke);
export default __webpack_public_path__ + "static/media/toke.ac0ed0d22200f9d62cdd2eae9a4a3202.svg";
export { ForwardRef as ReactComponent };